import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../global/functions/apiClient";
import { getAuthHeaders } from "../global/functions/authorization";
const apiUrl = process.env.REACT_APP_API_URL;
const initialState = {
  items: [],
  status: "idle",
  error: null,
  success: null,
  loading: false,
};

export const fetchRestaurants = createAsyncThunk(
  "restaurant/getAll",
  async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/restaurant/all`,
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const addRestaurant = createAsyncThunk(
  "restaurant/addRestaurant",
  async (body) => {
    try {
      const response = await axios.post(
        `${apiUrl}/restaurant`,
        body,
        getAuthHeaders(true)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const modifyRestaurant = createAsyncThunk(
  "restaurant/modifyRestaurant",
  async ({ body, restaurantId }) => {
    try {
      const response = await axios.put(
        `${apiUrl}/restaurant/${restaurantId}`,
        body,
        getAuthHeaders(true)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const updateRestaurantPositions = createAsyncThunk(
  "restaurant/updateRestaurantPositions",
  async ({ positions }) => {
    try {
      const response = await axios.put(
        `${apiUrl}/restaurant/position`,
        { positions },
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const deleteRestaurant = createAsyncThunk(
  "restaurant/deleteRestaurant",
  async (restaurantId) => {
    try {
      const response = await axios.delete(
        `${apiUrl}/restaurant/${restaurantId}`,
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

const restaurantsSlice = createSlice({
  name: "restaurants",
  initialState,
  reducers: {
    updateStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchRestaurants.pending, (state, action) => {
        state.status = "loadingFetchData";
        state.loading = true;
      })
      .addCase(fetchRestaurants.fulfilled, (state, action) => {
        state.status = "fetchData";
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchRestaurants.rejected, (state, action) => {
        state.status = "fetchError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addRestaurant.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(addRestaurant.fulfilled, (state, action) => {
        state.status = "addSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(addRestaurant.rejected, (state, action) => {
        state.status = "addError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteRestaurant.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(deleteRestaurant.fulfilled, (state, action) => {
        state.status = "deleteSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(deleteRestaurant.rejected, (state, action) => {
        state.status = "deleteError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(modifyRestaurant.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(modifyRestaurant.fulfilled, (state, action) => {
        state.status = "modifySuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(modifyRestaurant.rejected, (state, action) => {
        state.status = "modifyError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateRestaurantPositions.pending, (state, action) => {
        state.status = "loading1";
        state.loading = true;
      })
      .addCase(updateRestaurantPositions.fulfilled, (state, action) => {
        state.status = "updateRestaurantPositionSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(updateRestaurantPositions.rejected, (state, action) => {
        state.status = "updateRestaurantPositionError";
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { updateStatus } = restaurantsSlice.actions;
export const selectAllRestaurants = (state) => state.restaurants.items;
export const getRestaurantsStatus = (state) => state.restaurants.status;
export const getRestaurantsError = (state) => state.restaurants.error;
export const getRestaurantsSuccess = (state) => state.restaurants.success;
export const getRestaurantsLoading = (state) => state.restaurants.loading;
export default restaurantsSlice.reducer;
